import React, { useEffect, useState } from "react";
import { getSignUps } from "../../../services/signUpService";
import EnrolmentBarChart from "./EnrolmentBarChart";

const DailyBarChartWrapper = () => {
  const [signedUpData, setSignedUpData] = useState({
    0: null,
    1: null,
    2: null,
  });

  const signedUpLabels = ["Basic Info Only", "Payment Info Only", "Enrolled"];
  const options = {
    scales: {
      yAxes: [
        {
          stacked: true,
          ticks: {
            beginAtZero: true,
          },
        },
      ],
      xAxes: [
        {
          stacked: true,
        },
      ],
    },
  };
  const [total, setTotal] = useState(0);

  let date = new Date();

  const currentDate = new Date();
  const dateBefore = new Date(date.setDate(date.getDate() - 1));
  const startDate = dateBefore.toISOString();
  const endDate = currentDate.toISOString();

  const getData = () => {
    let fetches = [];

    const paramList = [
      {
        startDate: startDate,
        endDate: endDate,
        dropOuts: "basicInfo",
      },
      {
        startDate: startDate,
        endDate: endDate,
        dropOuts: "paymentInfo",
      },
      {
        startDate: startDate,
        endDate: endDate,
        enrolled: 1,
      },
    ];

    const signups = {};
    let totalCount = 0;

    paramList.forEach((param, index) => {
      fetches.push(
        getSignUps(1, 2, param)
          .then((response) => {
            const count = response.data.totalCount;
            signups[index] = count;
            totalCount = totalCount + count;
          })
          .catch((err) => console.log(err))
      );
    });

    // Wait for all fetches to finish
    Promise.all(fetches).then(function () {
      setTotal(totalCount);
      setSignedUpData(signups);
    });
  };

  const formatGraphData = (data) => {
    const dataValues = [];

    Object.keys(data).forEach((key) => {
      dataValues.push(data[key]);
    });

    return {
      labels: signedUpLabels,
      datasets: [
        {
          label: "No of people",
          data: dataValues,
          backgroundColor: [
            "rgba(255, 99, 132, 0.2)",
            "rgba(54, 162, 235, 0.2)",
            "rgba(255, 206, 86, 0.2)",
          ],
          borderColor: [
            "rgba(255, 99, 132, 1)",
            "rgba(54, 162, 235, 1)",
            "rgba(255, 206, 86, 1)",
          ],
        },
      ],
    };
  };

  useEffect(() => {
    getData();
  }, []);

  if (total > 0) {
    const title = `Daily - From ${dateBefore
      .toLocaleString()
      .replace(",", "")} to ${currentDate
      .toLocaleString()
      .replace(",", "")} - Total enrolment: ${signedUpData[2]}`;

    return (
      <div>
        <EnrolmentBarChart
          data={formatGraphData(signedUpData)}
          options={options}
          title={title}
        />
      </div>
    );
  } else {
    return <div>No record found</div>;
  }
};

export default DailyBarChartWrapper;
